/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/common';
import './gateway';
import '../../payments/reverse';
import '../api/reverse';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "VoidIntentIccData": {
                "fields": {
                  "applicationAuthenticationCryptogram": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "issuerScriptResults": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VoidIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "options": {
                    "type": "squareup.esperanto.common.ReverseOptions",
                    "id": 4,
                    "rule": "optional"
                  },
                  "iccData": {
                    "type": "squareup.esperanto.model.VoidIntentIccData",
                    "id": 5,
                    "rule": "optional"
                  },
                  "voidGatewayTransactionId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "clientRequestedAtMs": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "gatewayData": {
                    "type": "squareup.esperanto.model.GatewayData",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "VoidResult": {
                "fields": {
                  "status": {
                    "type": "squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": "squareup.payments.reverse.ReverseError",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Void": {
                "fields": {
                  "voidIntent": {
                    "type": "squareup.esperanto.model.VoidIntent",
                    "id": 1,
                    "rule": "optional"
                  },
                  "voidResult": {
                    "type": "squareup.esperanto.model.VoidResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "voidUuid": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "voidType": {
                    "type": "squareup.esperanto.api.VoidType",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.VoidIntentIccData && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.VoidIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.VoidResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Void) {
  $root.addJSON(jsonData);
}

/**
 * ICC-related data from the void.
 *
 * All of these fields are hex-encoded.
 *
 * SOURCE VoidIntentIccData @ squareup/esperanto/model/reverse.proto at 18:1
 */
export const VoidIntentIccData = $root.lookupType('squareup.esperanto.model.VoidIntentIccData');
fixType(VoidIntentIccData);
Builder.createAndAttachToType(VoidIntentIccData);
/**
 * Void intent.
 *
 * SOURCE VoidIntent @ squareup/esperanto/model/reverse.proto at 26:1
 */
export const VoidIntent = $root.lookupType('squareup.esperanto.model.VoidIntent');
fixType(VoidIntent);
Builder.createAndAttachToType(VoidIntent);
/**
 * Void result.
 *
 * SOURCE VoidResult @ squareup/esperanto/model/reverse.proto at 51:1
 */
export const VoidResult = $root.lookupType('squareup.esperanto.model.VoidResult');
fixType(VoidResult);
Builder.createAndAttachToType(VoidResult);
/**
 * Void transaction.
 *
 * SOURCE Void @ squareup/esperanto/model/reverse.proto at 62:1
 */
export const Void = $root.lookupType('squareup.esperanto.model.Void');
fixType(Void);
Builder.createAndAttachToType(Void);